import apiRoutes from "@/routes/apiRoutes";
import { CreateClientSecret, OrderQuotesDto, PlaceOrderDto } from "@/types";

export const getAllCategories = async () => {
  const response = await fetch(apiRoutes.category.list, {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
  });

  const result = await response.json();
  return result?.data;
};
export const getAllMenuItems = async () => {
  const response = await fetch(apiRoutes.product.list, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const result = await response.json();
  return result?.data;
};
export const getAllOrdersByUserId = async () => {
  const token = localStorage.getItem("auth_token");
  const response = await fetch(apiRoutes.order.getAllOrdersByUserId, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();
  return result?.data;
};
export const getOrderDetails = async (orderId:string) => {
  const response = await fetch(apiRoutes.order.orderDetails(orderId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
  });

  const result = await response.json();
  return result?.data;
};
export const placeOrder = async (orderDto: PlaceOrderDto) => {
  const token = localStorage.getItem("auth_token");
  const resp = await fetch(apiRoutes.order.place, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(orderDto),
  });
  const result = await resp.json();
  return {
    clientSecret: result?.data?.stripeClientSecret,
    paymentIntent: result?.data?.paymentIntentId,
    orderId: result?.data?.orderId,
    shippingAddressId: result?.data?.shippingAddressId,
  };
};
export const requestQuotes = async (orderDto: OrderQuotesDto) => {
  const token = localStorage.getItem("auth_token");
  const resp = await fetch(apiRoutes.order.orderQuotes, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(orderDto),
  });
  const result = await resp.json();
  return {
    quote_id: result?.data?.quote_id,
    is_available: result?.data?.is_available,
    fee: result?.data?.fee
  };
};
export const createPaymentIntent = async (
  clientSecretDTO: CreateClientSecret
) => {
  const token = localStorage.getItem("auth_token");
  const intentResponse = await fetch(apiRoutes.order.createPaymentIntent, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(clientSecretDTO),
  });
  return await intentResponse.json();
};
